























import { Component, Vue, Prop } from 'vue-property-decorator';
import { ScreenText } from '@/lang/ScreenText';
import MobileDiscountTooltip from './MobileDiscountTooltip.vue';

@Component({
  components: {
    MobileDiscountTooltip,
  }
})

export default class SessionDiscountBadge extends Vue {
  @Prop({ type: String, required: true }) discountName!: string;
  @Prop({ type: String, required: true }) discountAmount!: string;
  @Prop({ type: String, required: true }) discountDescription!: string;

  //coordinate with gilbert to make this mandatory, if I do it right now, it will break the build for the pages he is working on
  @Prop({ type: String, required: false }) discountUnit!: string;
  @Prop({ type: Boolean, required: true }) isMobile!: boolean;

  private screenText: ScreenText = new ScreenText();

  get formattedDiscountAmount(): string {
    return `${this.discountName} (${this.discountAmount} ${this.screenText.getScreenText('DISCOUNT_LABEL_OFF')})`;
  }
}
